import { TransactionStatus } from '../models/status.model'

export interface AchStatusConfig {
    label: string;
    color: 'green' | 'red' | 'yellow' | 'blue' | 'purple';
    tooltip: string;
    cssClass: string;
}

export const ACH_STATUS_CONFIG: Record<TransactionStatus, AchStatusConfig> = {
    // Green: positive terminal states
    [TransactionStatus.Approved]: {
        label: 'Approved',
        color: 'green',
        tooltip: 'Transaction approved',
        cssClass: 'status-badge--approved',
    },
    [TransactionStatus.Funded]: {
        label: 'Funded',
        color: 'green',
        tooltip: 'Funds transferred to merchant',
        cssClass: 'status-badge--funded',
    },
    [TransactionStatus.Settled]: {
        label: 'Settled',
        color: 'green',
        tooltip: 'Transaction settled',
        cssClass: 'status-badge--settled',
    },
    // Yellow: warning / attention / in-progress
    [TransactionStatus.Pending]: {
        label: 'Pending',
        color: 'yellow',
        tooltip: 'Transaction pending',
        cssClass: 'status-badge--pending',
    },
    [TransactionStatus.Unsettled]: {
        label: 'Unsettled',
        color: 'yellow',
        tooltip: 'Pending settlement',
        cssClass: 'status-badge--unsettled',
    },
    [TransactionStatus.ReturnRetry]: {
        label: 'Return Retry',
        color: 'yellow',
        tooltip: 'Return retry pending',
        cssClass: 'status-badge--return-retry',
    },
    [TransactionStatus.PostSettleReturn]: {
        label: 'Post Settle Return',
        color: 'yellow',
        tooltip: 'Post-settled return',
        cssClass: 'status-badge--post-settle-return',
    },
    [TransactionStatus.NocReceived]: {
        label: 'NOC Received',
        color: 'yellow',
        tooltip: 'Notification of Change received',
        cssClass: 'status-badge--noc-received',
    },
    // Red: failure / negative terminal states
    [TransactionStatus.Returned]: {
        label: 'Returned',
        color: 'red',
        tooltip: 'Transaction returned',
        cssClass: 'status-badge--returned',
    },
    [TransactionStatus.Declined]: {
        label: 'Declined',
        color: 'red',
        tooltip: 'Transaction declined',
        cssClass: 'status-badge--declined',
    },
    [TransactionStatus.Failed]: {
        label: 'Failed',
        color: 'red',
        tooltip: 'Transaction failed',
        cssClass: 'status-badge--failed',
    },
    [TransactionStatus.RefundFailed]: {
        label: 'Refund Failed',
        color: 'red',
        tooltip: 'Refund failed',
        cssClass: 'status-badge--refund-failed',
    },
    [TransactionStatus.PartialRefundFailed]: {
        label: 'Partial Refund Failed',
        color: 'red',
        tooltip: 'Partial refund failed',
        cssClass: 'status-badge--partial-refund-failed',
    },
    [TransactionStatus.Voided]: {
        label: 'Voided',
        color: 'red',
        tooltip: 'Transaction voided',
        cssClass: 'status-badge--voided',
    },
    [TransactionStatus.Cancelled]: {
        label: 'Cancelled',
        color: 'red',
        tooltip: 'Transaction cancelled',
        cssClass: 'status-badge--cancelled',
    },
    [TransactionStatus.TimedOut]: {
        label: 'Timed Out',
        color: 'red',
        tooltip: 'Transaction timed out',
        cssClass: 'status-badge--timed-out',
    },
    // Blue: refund-resolved states
    [TransactionStatus.Refunded]: {
        label: 'Refunded',
        color: 'blue',
        tooltip: 'Full refund processed',
        cssClass: 'status-badge--refunded',
    },
    [TransactionStatus.PartiallyRefunded]: {
        label: 'Partially Refunded',
        color: 'blue',
        tooltip: 'Partial refund processed',
        cssClass: 'status-badge--partially-refunded',
    },
    // Purple: submitted / initiated
    [TransactionStatus.Submitted]: {
        label: 'Submitted',
        color: 'purple',
        tooltip: 'Transaction submitted',
        cssClass: 'status-badge--submitted',
    },
}

export function getStatusConfig(status: TransactionStatus): AchStatusConfig {
    return ACH_STATUS_CONFIG[status]
}
